import { render, staticRenderFns } from "./PopupForNewbie.vue?vue&type=template&id=17e10440&scoped=true&"
import script from "./PopupForNewbie.vue?vue&type=script&lang=js&"
export * from "./PopupForNewbie.vue?vue&type=script&lang=js&"
import style0 from "./PopupForNewbie.vue?vue&type=style&index=0&id=17e10440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e10440",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
